import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../../redux/connect';
import { withRouter } from 'react-router-dom';
import {
  changeLocationAction,
  setQueryParamsAction,
  navigateToIssueInDocumentAction,
  trackEvent,
} from '../../../../redux/actions';
import {
  getFetchParams,
  getDocumentCollection,
  getFetchingIssuesUrns,
  getCurrentUserInMcFormat,
  getOxygenMappings,
  getProjectId,
} from '../../../../redux/selectors';
import { issuesFetchParamsType, issueWrapperArrayType, documentCollectionType, userType, oxygenType } from '../../../../constants/proptype-validation';
import ProjectListMatrixTable from './components/ProjectListMatrixTable';
import { get as lodashGet } from 'lodash';
import { issueLink } from '../../../../utils/issues-helpers';
import { SORTING_PARAMS, PAGE_PARAMS } from '../../../../constants/issue-query-params';

export class PureProjectList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentSort: this.getSortFromFetchParams(props.fetchParams),
    };
    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleTableRowClick = this.handleTableRowClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (lodashGet(nextProps, `fetchParams.queryParams.${SORTING_PARAMS.SORT}`) !== lodashGet(this.props, `fetchParams.queryParams.${SORTING_PARAMS.SORT}`)) {
      this.setState({ currentSort: this.getSortFromFetchParams(nextProps.fetchParams) });
    }
  }

  getSortFromFetchParams(fetchParams) {
    const defaultSortValue = 'custom_identifier';
    let sortField = lodashGet(fetchParams, `queryParams.${SORTING_PARAMS.SORT}`, defaultSortValue);

    let isAscending = true;

    if (sortField.startsWith('-')) {
      sortField = sortField.substring(1);
      isAscending = false;
    }

    return { sortField, isAscending };
  }

  getFetchParamFromCurrentSort() {
    const { currentSort } = this.state;
    const dash = currentSort.isAscending ? '' : '-';

    return `${dash}${currentSort.sortField}`;
  }

  handleSortChange(sort) {
    const newSort = this.getFetchParamFromCurrentSort() === sort ? `-${sort}` : sort;

    this.props.setQueryParamsAction({ [SORTING_PARAMS.SORT]: newSort, [PAGE_PARAMS.OFFSET]: 0 });
  }

  handleTableRowClick({ attributes }) {
    const { changeLocationAction } = this.props;
    changeLocationAction(`/project/rfis/${attributes.id}`);
  }

  render() {
    const { issues, documentCollection, navigateToIssueInDocumentAction, location, fetchingIssuesUrns,
      currentUser, oxygen, trackEvent, projectId } = this.props;

    const rowLinkEnabled = typeof issueLink.func === 'function';

    return (
      <div className="ProjectList">
        <ProjectListMatrixTable
          tableData={issues}
          currentSort={this.state.currentSort}
          onSort={this.handleSortChange}
          onRowClick={this.handleTableRowClick}
          documentCollection={documentCollection}
          fetchingIssuesUrns={fetchingIssuesUrns}
          location={location}
          navigateToIssueInDocumentAction={navigateToIssueInDocumentAction}
          rowLinkEnabled={rowLinkEnabled}
          currentUser={currentUser}
          oxygen={oxygen}
          trackEvent={trackEvent}
          projectId={projectId}
        />
      </div>
    );
  }
}

PureProjectList.displayName = 'ProjectList';

PureProjectList.propTypes = {
  fetchParams: issuesFetchParamsType.isRequired,
  documentCollection: documentCollectionType.isRequired,
  fetchingIssuesUrns: PropTypes.array,
  issues: issueWrapperArrayType.isRequired,
  changeLocationAction: PropTypes.func.isRequired,
  setQueryParamsAction: PropTypes.func.isRequired,
  navigateToIssueInDocumentAction: PropTypes.func.isRequired,
  location: PropTypes.object,
  currentUser: userType,
  oxygen: oxygenType.isRequired,
  trackEvent: PropTypes.func,
  projectId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  fetchParams: getFetchParams(state),
  documentCollection: getDocumentCollection(state),
  fetchingIssuesUrns: getFetchingIssuesUrns(state),
  currentUser: getCurrentUserInMcFormat(state),
  oxygen: getOxygenMappings(state),
  projectId: getProjectId(state),
});

export default withRouter(connect(mapStateToProps, {
  changeLocationAction,
  setQueryParamsAction,
  navigateToIssueInDocumentAction,
  trackEvent,
})(PureProjectList));
